const outputDoc = {
  title: 'Last will',
  from: 'from',
  born: ' born on ',
  civilStatus: {
    single: 'Single',
    married: 'Married',
    widowed: 'Widowed',
    divorced: 'Divorced',
    registered_partnership: 'Registered partnership',
  },
  civil_status: 'Civil status: {{civil_status}}',
  address: 'Address: {{address}}',
  declare: 'I, {{first_name}} {{last_name}}, declare the following:  ',

  paragraph1: 'I revoke all wills I have previously made.',

  paragraph2:
    'The ongoing liabilities and death costs are to be paid from the estate.',

  paragraph3: '{{civil_status}}',

  receivesNothing: 'receives nothing.',

  and: 'and',

  p4MarriedSpouse: {
    marriedStatus: {
      male: 'My wife',
      female: 'My husband',
    },
    livingPartnershipStatus: {
      male: 'My registered partner (female)',
      female: 'My registered partner (male)',
    },
    partnerStatus: {
      male: 'My partner',
      female: 'My partner',
    },
    born: ', born on {{birthday}}, ',
    receivesAsHeir: 'receives as heir the entire available quota.',
  },

  marriedSpouseChildren: {
    biologicalChildren: {
      oneChild: {
        main: 'My biological and legally recognized child ',
        born: ', born on {{birthday}}, ',
        receive: 'receives their compulsory portion of my estate.',
      },
      multipleChildren: {
        main: 'My biological and legally recognized children ',
        born: ', born on {{birthday}}, ',
        receive: 'each receive their compulsory portion of my estate.',
      },
    },
  },

  marriedSpouseUsufruct: {
    marriedStatus: {
      male: 'To my wife',
      female: 'To my husband',
    },
    livingPartnershipStatus: {
      male: 'To my registered partner (female)',
      female: 'To my registered partner (male)',
    },
    usufructRights:
      'I also grant lifelong usufruct over the compulsory portion of my children.',
  },

  p4UnmarriedPartner: {
    receives: 'receives the entire freely available quota.',
    receivesProperty: 'also receives in particular',
    theProperty: 'the property',
    atTheAddress: 'at the address',
    assignedToProperty: 'assigned to ownership.',
    born: ', born on {{birthday}}, ',
    genderStatus: {
      male: 'My partner (female)',
      female: 'My partner (male)',
      male1: 'my partner (female)',
      female1: 'my partner (male)',
      registeredPartnerMale: 'My registered partner (female)',
      registeredPartnerFemale: 'My registered partner (male)',
    },
  },

  p5UnmarriedPartnerWithChildren: {
    commonPartnership: {
      oneChild: {
        main: 'Our common child, ',
        born: ', born on {{birthday}}, ',
        receive: 'or their descendants receive the compulsory portion.',
      },
      multipleChildren: {
        main: 'Our common children, ',
        born: ', born on {{birthday}}, ',
        receive:
          'or all their descendants each receive the compulsory portion.',
      },
      and: 'and',
    },
    otherPartnership: {
      oneChild: {
        main: 'My non-common child, ',
        born: ', born on {{birthday}}, ',
        receive: 'or their descendants receive the compulsory portion.',
      },
      multipleChildren: {
        main: 'My non-common children, ',
        born: ', born on {{birthday}}, ',
        receive:
          'or all their descendants each receive an equal share of the compulsory portion.',
      },
    },
    noPartnership: {
      oneChild: {
        main: 'My child, ',
        born: ', born on {{birthday}}, ',
        receive: ' or their descendants receive the compulsory portion.',
      },
      multipleChildren: {
        main: 'My children, ',
        born: ', born on {{birthday}}, ',
        receive:
          ' or all their descendants each receive the compulsory portion.',
      },
    },
    deathCase:
      'Should I die simultaneously with {{partner}}, then {{childrenCase}}',
    born: ', born on {{birthday}}, ',
    childrenCase: {
      oneChild: {
        fromCommonMarriage: 'our common child receives, ',
        fromOtherMarriage: 'our non-common child receives, ',
        fromUnknownMarriage: 'my child receives,',
      },
      onesDescendants: 'or their descendants all assets.',
      multipleChildren: {
        fromCommonMarriage: 'our common children receive, ',
        fromOtherMarriage: 'our non-common children receive, ',
        fromUnknownMarriage: 'my children receive, ',
      },
      allDescendants: 'or all their descendants each receive all assets.',
    },
  },

  p4Child: {
    biologicalChildren: {
      oneChild: {
        main: 'I appoint my child ',
        born: ', born on {{birthday}}, ',
        receive: 'as heir to my entire estate. It receives my entire estate.',
      },
      multipleChildren: {
        main: 'I appoint my children ',
        born: ', born on {{birthday}}, ',
        receive:
          'in equal shares as heirs to my entire estate. They each receive half of my estate.',
      },
    },
    partnerCase: {
      male: 'My wife',
      female: 'My husband',
      born: ', born on {{birthday}}, ',
      receivesNothing: 'shall receive no allocation from my estate.',
      receivesCompulsoryPortion:
        'receives their compulsory portion from my estate.',
    },
  },

  unmarriedChildrenChoice: {
    biologicalChildren: {
      oneChild: {
        main: 'I appoint my child ',
        born: ', born on {{birthday}}, ',
        receive: 'as heir to my entire estate. It receives my entire estate.',
      },
      multipleChildren: {
        main: 'I appoint my children ',
        born: ', born on {{birthday}}, ',
        receive:
          'in equal shares as heirs to my entire estate. They each receive half of my estate.',
      },
    },
  },

  unmarriedPartnerCase: {
    male: 'My life partner (female)',
    female: 'My life partner (male)',
    born: ', born on {{birthday}}, ',
    receivesNothing: 'shall receive no allocation from my estate.',
  },

  unmarriedPartnerDeathCase: {
    male: 'Should I die simultaneously with my life partner (female) or she does not survive the inheritance event, then receives',
    female:
      'Should I die simultaneously with my life partner (male) or he does not survive the inheritance event, then receives',
    multipleChildren: 'my child, ',
    oneChild: 'my child, ',
    born: ', born on {{birthday}}, ',
    descendants: 'or their descendants',
    multipleDescendants: 'or their descendants',
    inheritAll:
      'the entire estate in equal shares with other heirs (if any) or alone if no other legal heirs exist.',
    and: 'as well as',
  },

  unmarriedInstitutionChoice: {
    biologicalChildren: {
      oneChild: {
        main: 'My biological and legally recognized child, ',
        born: ', born on {{birthday}}, ',
        receive: 'receives their compulsory portion of my estate.',
      },
      multipleChildren: {
        main: 'My biological and legally recognized children, ',
        born: ', born on {{birthday}}, ',
        receive: 'each receive their compulsory portion of my estate.',
      },
    },
  },

  p4Institution: {
    oneInstitution: {
      main: 'The institution',
      receives: 'receives',
    },
    multipleInstitutions: {
      main: 'The institutions',
      receives: 'receive',
    },
    finals:
      ' each receive an equal share of all assets within the freely available quota. ',
    final: ' all assets within the freely available quota. ',
    partnerReceives: 'receives her compulsory portion from my estate.',
    born: ', born on {{birthday}}, ',
    and: ' and ',
  },

  p5MarriedSpouse: {
    marriedStatus: {
      male: 'My wife',
      female: 'My husband',
    },
    livingPartnershipStatus: {
      male: 'My registered partner (female)',
      female: 'My registered partner (male)',
    },
    particularReceives: {
      marriedStatus:
        'My wife shall receive the property at {{address}} as sole ownership within the available quota. If the available quota is not sufficient for this, the allocation shall be made with credit to her inheritance share.',
      livingPartnershipStatus:
        'My registered partner shall receive the property at {{address}} as sole ownership within the available quota. If the available quota is not sufficient for this, the allocation shall be made with credit to her inheritance share.',
    },
    theProperty: 'the property',
    atTheAddress: 'at the address',
    assignedToProperty: 'assigned to ownership.',
  },

  spouseSimultaneousDeathClause:
    'Should {{partnerTerminology}} {{partnerFullNameAndBirthday}} die simultaneously with me or not survive the inheritance event, the available quota of my estate falls to my two children {{childrenNames}} in equal shares.',

  p5Institution: {
    commonMarriage: {
      oneChild: {
        main: 'Our common child, ',
        born: ' born on {{birthday}}, ',
        receive: 'or their descendants receive the compulsory portion.',
      },
      multipleChildren: {
        main: 'Our common children, ',
        born: ' born on {{birthday}}, ',
        receive:
          'or all their descendants each receive the compulsory portion.',
      },
      and: 'and',
    },
    otherMarriage: {
      oneChild: {
        main: 'My non-common child, ',
        born: ' born on {{birthday}}, ',
        receive: 'or their descendants receive the compulsory portion.',
      },
      multipleChildren: {
        main: 'My non-common children, ',
        born: ' born on {{birthday}}, ',
        receive:
          'or all their descendants each receive the compulsory portion.',
      },
      and: 'and',
    },
  },

  p6MarriedSpouse: {
    oneChild: {
      commonMarriage: 'Our common child, ',
      otherMarriage: 'My non-common child, ',
      born: ', born on {{birthday}}, ',
      receives: 'or their descendants receive ',
    },
    multipleChildren: {
      commonMarriage: 'Our common children, ',
      otherMarriage: 'My non-common children, ',
      born: ', born on {{birthday}}, ',
      receives: 'or all their descendants each receive',
    },
    final:
      'the compulsory portion, however burdened with the usufruct mentioned in the first paragraph. ',
  },

  willExecutor:
    'As executor for my entire estate, I appoint {{executor1}}. As substitute executor, I appoint {{executor2}}.',

  forFollowing: {
    main: 'However, the following assets are subject to a different regulation:',
    asset: '{{asset}}, {{address}} goes to: {{benefiter}}. ',
    devisionProvision:
      'This is a division provision in favor of {{benefiter}}, not an additional benefit.',
  },
  optionalUsufruct: {
    marriedMale: 'My wife',
    marriedFemale: 'My husband',
    partnerMale: 'My registered partner (female)',
    partnerFemale: 'My registered partner (male)',
    receives: ' receives the lifelong right of usufruct',
    propertyPart: ' on my property at {{address}}',
    andOr: ' and/or',
    estatePart:
      ' on parts of my estate, insofar as this is compatible with the rights of the statutory or appointed heirs.',
  },
};

export default outputDoc;
